import {
  Flex,
  HStack,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Plus, LogOut, Pencil, Users, MessageSquare, LayoutDashboard } from "../icons";
import { AvatarInitials, BrandLogo } from "../ui";
import { useAuth } from "../../features/auth/hooks/useAuth";
import { isAdmin } from "../../features/auth/lib/roles";
import NotificationsPopover from "../../features/alertas/components/NotificationsPopover";
import MobileDrawer from "./MobileDrawer";
import ColorModeToggle from "./ColorModeToggle";

export default function Navbar({ alertas = [], alertasLoading, alertasError, onRegistrarPlantao }) {
  const { user, perfil, logout } = useAuth();
  const navigate = useNavigate();
  const mobileMenu = useDisclosure();

  const nome = perfil?.nome_completo || user?.email || "Você";

  const handleLogout = async () => {
    await logout();
    navigate("/auth/login");
  };

  return (
    <Flex
      as="header"
      h="58px"
      align="center"
      justify="space-between"
      px={4}
      bg="app-navbar"
      borderBottom="1px solid"
      borderColor="app-border"
      position="sticky"
      top={0}
      zIndex="sticky"
      gap={3}
    >
      <HStack spacing={3} flexShrink={0}>
        <MobileDrawer isOpen={mobileMenu.isOpen} onClose={mobileMenu.onClose} onOpen={mobileMenu.onOpen} onRegistrarPlantao={onRegistrarPlantao} />
        <Box>
          <BrandLogo h="22px" />
          <Text fontSize="10px" color="app-muted-fg" display={{ base: "none", md: "block" }}>
            Gestão financeira do plantonista PJ
          </Text>
        </Box>
      </HStack>

      <HStack spacing={2} flexShrink={0}>
        <Button leftIcon={<Plus size={16} />} onClick={onRegistrarPlantao} display={{ base: "none", sm: "inline-flex" }}>
          Registrar plantão
        </Button>
        <ColorModeToggle />
        <NotificationsPopover alertas={alertas} isLoading={alertasLoading} isError={alertasError} />
        <Menu>
          <MenuButton>
            <AvatarInitials name={nome} size="sm" cursor="pointer" />
          </MenuButton>
          <MenuList>
            <MenuItem icon={<Pencil size={16} />} onClick={() => navigate("/perfil")}>
              Meu perfil
            </MenuItem>
            {isAdmin(user) ? (
              <>
                <MenuItem icon={<LayoutDashboard size={16} />} onClick={() => navigate("/admin")}>
                  Visão geral (admin)
                </MenuItem>
                <MenuItem icon={<Users size={16} />} onClick={() => navigate("/admin/usuarios")}>
                  Usuários
                </MenuItem>
                <MenuItem icon={<MessageSquare size={16} />} onClick={() => navigate("/admin/feedbacks")}>
                  Feedbacks
                </MenuItem>
              </>
            ) : null}
            <MenuItem icon={<LogOut size={16} />} onClick={handleLogout}>
              Sair
            </MenuItem>
          </MenuList>
        </Menu>
      </HStack>
    </Flex>
  );
}
